// extracted by mini-css-extract-plugin
module.exports = {"container":"Manifesto_container__9iivA","illustration":"Manifesto_illustration__xxyes","copy":"Manifesto_copy__1mTr1"};